<template>
  <el-dialog title="运输详情" :visible.sync="showDialog" width="900px">
    <div v-loading="loading">
      <el-card shadow="never">
        <div slot="header" class="clearfix">
          <h3 style="display:inline-block">订单信息</h3>
          <el-button type="text" style="float: right;padding-left:10px" v-if="!waybillTaskData.subTasks && waybillTaskData.isTransferTerminateRent" @click="onExport('装货签收单', 'terminateRentDoc', waybillTaskData, 'png')">导出装货签收单</el-button>
          <el-button type="text" style="float: right;padding-left:10px" v-if="isDesignateDriver" @click="onDesignateDriver">安排司机</el-button>
          <el-button type="text" style="float: right;padding-left:10px;color:#67c23a" v-if="waybillTaskData.exceptionFlag" @click="onMarkLogistic(false)">标记正常</el-button>
          <el-button type="text" style="float: right;padding-left:10px;color:#f56c6c" v-else @click="onMarkLogistic(true)">标记异常</el-button>
          <el-button type="text" style="float: right" @click="onAddRemark">添加备注</el-button>
        </div>
        <div class="task-order">
          <p>任务编号：<span>{{ waybillTaskData.logisticTaskId }}</span></p>
          <p>派单日期：<span>{{ pltFormatter.date(waybillTaskData.dispatcherTime) }}</span></p>
        </div>
        <ul class="sub-task">
          <li>
            <div class="address">
              <p class="badge success">起</p>
              <div class="region">
                <plt-dict-box namespace="region" id="fullArea" :value="waybillTaskData.fromAreaId"></plt-dict-box>
                <p>{{ waybillTaskData.fromAddr }}</p>
              </div>
            </div>
            <p><i class="el-icon-office-building"></i>装货客户:<span>
                <plt-dict-box namespace="bizObjects" id="member" :value="waybillTaskData.fromMemberId"></plt-dict-box>
              </span>
            </p>
            <p><i class="el-icon-user"></i>装货联系人:
              <plt-dict-box namespace="bizObjects" id="contact" :value="waybillTaskData.fromLinkmanId" />
            </p>
            <p><i class="el-icon-phone-outline" v-if="waybillTaskData.fromLinkmanMobile"></i>装货联系人手机号:<span>{{ waybillTaskData.fromLinkmanMobile }}</span></p>
          </li>
          <li class="line">
            <plt-dict-box namespace="target" id="type" v-if="waybillTaskData.targetType" :value="waybillTaskData.targetType" />
            <span v-if="waybillTaskData.goodsName">{{waybillTaskData.goodsName}}</span>
            ({{ waybillTaskData.planQty }}片)
            <span class="long-line">───────────────></span>
            <plt-dict-box style="color:#FF8800" namespace="logistic" id="logisticSubTaskProxyStatus" :value="waybillTaskData.status" />
          </li>
          <li>
            <div class="address">
              <p class="badge warning">终</p>
              <div class="region">
                <plt-dict-box namespace="region" id="fullArea" :value="waybillTaskData.toAreaId"></plt-dict-box>
                <p>{{ waybillTaskData.toAddr }}</p>
              </div>
            </div>

            <p><i class="el-icon-office-building"></i>卸货客户:<span>
                <plt-dict-box namespace="bizObjects" id="member" :value="waybillTaskData.toMemberId"></plt-dict-box>
              </span></p>
            <p><i class="el-icon-user"></i>卸货联系人:
              <plt-dict-box namespace="bizObjects" id="contact" :value="waybillTaskData.toLinkmanId" />
            </p>
            <p><i class="el-icon-phone-outline" v-if="waybillTaskData.toLinkmanMobile"></i>卸货联系人手机号:<span>{{ waybillTaskData.toLinkmanMobile }}</span></p>
          </li>
        </ul>
        <p class="plt-remark" v-if="waybillTaskData.remark">在线派工备注：<span>{{ waybillTaskData.remark }}</span></p>
        <p class="plt-remark" v-if="waybillTaskData.customerRemark">客户备注：<span>{{ waybillTaskData.customerRemark }}</span></p>
        <p class="plt-remark" v-if="waybillTaskData.carrierRemark">承运备注：<span>{{ waybillTaskData.carrierRemark }}</span></p>
      </el-card>
      <el-card style="margin-top:10px" shadow="never" v-if="waybillTaskData.subTasks">
        <div slot="header" class="clearfix">
          <h3 style="display:inline-block">车辆安排</h3>
        </div>
        <section v-for="(item, index) in waybillTaskData.subTasks" :key="item.logisticSubTaskId">
          <el-divider v-if="index != 0"></el-divider>
          <div class="push-btn">
            <el-button type="text" v-if="item.proxyStatus !== 'finish'&&waybillTaskData.subTaskDeletable" @click="onCancelLogisticSubTask(item.logisticSubTaskId)">取消子任务</el-button>
            <el-button type="text" v-if="item.proxyStatus === 'to_handover'||item.proxyStatus === 'to_arrange_driver'" @click="onUpdateDriver(item.waybillId,waybillTaskData.dispatcherId,item.plateNo,item.vehicleTypeId,item.linkmanId,item.driverIdentityNo,item.driverMobile)">更换司机</el-button>
            <el-button type="text" v-if="item.proxyStatus === 'to_handover'" @click="onPushSignature(item)">上传签收单</el-button>
            <el-button type="text" v-if="item.proxyStatus === 'to_handover' && item.linkmanId" @click="onCancelDriver(item.logisticSubTaskId)">取消司机安排</el-button>
            <el-button type="text" icon="el-icon-download" style="color:#67c23a" @click="onZhExportSingle(item)" v-if="waybillTaskData.bizType && item.status !== 'to_arrange_driver' && (waybillTaskData.bizType === 'TERMINATE_START_RENT' || waybillTaskData.bizType === 'TERMINATE_RENT') && isZhLease">中化签收单</el-button>
            <el-button type="text" icon="el-icon-download" style="color:#67c23a" @click="onExportSingle(waybillTaskData.bizType,item,waybillTaskData.logisticTaskId)" v-if="(waybillTaskData.goodsName&&item.status !== 'to_arrange_driver'&&item.linkmanId)||(waybillTaskData.bizType&&waybillTaskData.bizType!=='TERMINATE_START_RENT'&&((item.status !== 'to_arrange_driver'&&item.linkmanId)|| (carrierMemberId=='3546'&&waybillTaskData.bizType=='TERMINATE_RENT' )))">签收单</el-button>
            <template v-if="waybillTaskData.bizType&&waybillTaskData.bizType==='TERMINATE_START_RENT'&&item.linkmanId&&item.status!=='to_arrange_driver'">
              <el-button type="text" icon="el-icon-download" style="color:#e6a23c" @click="onExportSingle(waybillTaskData.bizType,item,waybillTaskData.logisticTaskId,`装货单`)">装货单</el-button>
              <el-button type="text" icon="el-icon-download" style="color:#e6a23c" @click="onExportSingle(waybillTaskData.bizType,item,waybillTaskData.logisticTaskId,`卸货单`)">卸货单</el-button>
            </template>
          </div>
          <el-descriptions title="" :column="3" :contentStyle="{ color: '#909399' }">
            <el-descriptions-item label="子任务编号">{{ item.logisticSubTaskId }}</el-descriptions-item>
            <el-descriptions-item label="状态">
              <el-tag v-if="item.proxyStatus === 'to_arrange_driver'" type="primary">待派车</el-tag>
              <el-tag v-else-if="item.proxyStatus === 'to_handover'" type="warning">待交接</el-tag>
              <el-tag v-else-if="item.proxyStatus === 'handover'" type="danger">已交接</el-tag>
              <el-tag v-else-if="item.proxyStatus === 'finish'" type="success">已完成</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="数量">{{ item.planQty }}</el-descriptions-item>
            <el-descriptions-item label="司机名称">
              <plt-dict-box namespace="bizObjects" id="contact" :value="item.linkmanId" />
            </el-descriptions-item>
            <el-descriptions-item label="车型">
              <plt-dict-box namespace="logistic" id="vehicleType" :value="item.vehicleTypeId" />
            </el-descriptions-item>
            <el-descriptions-item label="车牌号">{{ item.plateNo }}</el-descriptions-item>
            <el-descriptions-item label="司机联系方式">{{ item.driverMobile }}</el-descriptions-item>
            <el-descriptions-item label="派车时间" v-if="item.dispatcherDate">{{ item.dispatcherDate }}</el-descriptions-item>
            <el-descriptions-item label="预计上门日期">{{pltFormatter.date(item.expectedLoadDate)}}</el-descriptions-item>
          </el-descriptions>
          <div class="carrier">
            <el-divider content-position="left" v-if="item.proxyShippingNoteId || item.proxyReceiveNoteId">承运商录入交接信息</el-divider>
            <ul class="content" v-if="item.proxyShippingNoteId || item.proxyReceiveNoteId">
              <li>
                <p v-show="item.proxyShippingDate"><i class="el-icon-time"></i>装货日期:<span>{{ pltFormatter.date(item.proxyShippingDate) }}</span></p>
                <p v-show="item.proxyShippingQty"><i class="el-icon-coin"></i>装货数量:<span>{{ item.proxyShippingQty }}</span></p>
                <!-- <p v-show="item.proxyShippingLinkman"><i class="el-icon-coin"></i>最终联系人:<span>{{ item.proxyShippingLinkman }}</span></p>
                <p v-show="item.proxyShippingLinkmanPhone"><i class="el-icon-coin"></i>最终联系人手机号:<span>{{ item.proxyShippingLinkmanPhone }}</span></p>
                <p v-show="item.proxyShippingAddress"><i class="el-icon-coin"></i>实际交接地址:<span>{{ item.proxyShippingAddress }}</span></p> -->
                <p class="remark" v-show="item.proxyHandoverRemark"><i class="el-icon-edit-outline"></i>交接备注:<span>{{ item.proxyHandoverRemark }}</span></p>

                <div class="btns">
                  <el-button type="text" v-if="item.proxyShippingNoteId" @click="openViewer(item.proxyShippingNoteId)">装货交接单</el-button>
                </div>

              </li>
              <li class="no-line"></li>

              <li>
                <p v-show="item.proxyReceiveDate"><i class="el-icon-time"></i>卸货日期:<span>{{ pltFormatter.date(item.proxyReceiveDate) }}</span></p>
                <p v-show="item.proxyReceiveQty"><i class="el-icon-coin"></i>卸货数量:<span>{{ item.proxyReceiveQty }}</span></p>

                <div class="btns">
                  <el-button type="text" v-if="item.proxyReceiveNoteId" @click="openViewer(item.proxyReceiveNoteId)">卸货交接单</el-button>
                </div>
              </li>
            </ul>

            <el-divider content-position="left" v-if="isHistoryWaybill">普拉托交接信息</el-divider>
            <ul class="content" v-show="isHistoryWaybill">
              <li>
                <p><i class="el-icon-time"></i>装货日期:<span>{{ pltFormatter.date(item.shippingDate) }}</span></p>
                <p><i class="el-icon-coin"></i>装货数量:<span>{{ item.shippingQty }}</span></p>

              </li>
              <li class="no-line"></li>
              <li>
                <p><i class="el-icon-time"></i>卸货日期:<span>{{ pltFormatter.date(item.receiveDate) }}</span></p>
                <p><i class="el-icon-coin"></i>卸货数量:<span>{{ item.receiveQty }}</span></p>
              </li>
            </ul>

          </div>
        </section>

      </el-card>
    </div>
    <select-logistic-driver ref="selectLogisticDriverRef" @onFinish="onFinishSeleDriver" />
    <push-signature ref="pushSignatureRef" @onFinish="onFinish" />
    <arrangeDriverVehicle ref="arrangeDriverVehicleRef" @onFinish="onFinishSeleDriver" />
    <add-remark ref="addRemarkRef" @onFinish="onFinishSeleDriver" />
    <el-image-viewer ref="elImageViewerRef" />

  </el-dialog>
</template>

<script>
import elImageViewer from "./el-image-viewer.vue";
import selectLogisticDriver from "./select-logistic-driver.vue";
import pushSignature from "./push-signature.vue";
import arrangeDriverVehicle from "./arrange-driver-vehicle.vue";
import addRemark from "./add-remark.vue";

import { Loading } from "element-ui";
export default {
  components: { selectLogisticDriver, pushSignature, addRemark, elImageViewer, arrangeDriverVehicle },
  data() {
    return {
      carrierMemberId: sessionStorage.getItem("memberId"),
      showDialog: false,
      loading: false,
      waybillTaskData: {},
      isHistoryWaybill: false,
      logisticsTaskId: "",
      isDesignateDriver: false,
      isZhLease: false
    };
  },
  methods: {
    async openDialog(logisticsTaskId) {
      this.showDialog = true;
      this.logisticsTaskId = logisticsTaskId;
      this.isZhLease = false;
      await this.getData(logisticsTaskId);
      this.getIsZhLeasee();
    },
    async getData(logisticsTaskId) {
      this.loading = true;
      let url = "http://MID-OPERATE-LOGISTICS/messageService/carrierProxyQueryService/carrierQueriesLogisticsTaskDetail";

      this.waybillTaskData = await this.invoke(url, { logisticsTaskId }).finally(() => (this.loading = false));
      let notPlanQty = this.waybillTaskData.planQty - (this.waybillTaskData?.subTasks ? this.waybillTaskData?.subTasks?.reduce((total, item) => (total += item.planQty), 0) ?? 0 : 0);

      this.isDesignateDriver = notPlanQty > 0 ? true : false;
    },
    onFinish() {
      this.getData(this.logisticsTaskId);
    },
    // 取消子任务
    onCancelLogisticSubTask(id) {
      let url = "http://MID-OPERATE-LOGISTICS/messageService/carrierProxyService/carrierCancelLogisticSubTask";
      this.cfmInvoke(url, { logisticSubTaskId: id }, { msg: "确定取消子任务？" }).then(() => {
        this.$message.success("操作成功");
        this.$emit("onFinish");
        this.onFinish();
      });
    },
    // 安排司机
    onDesignateDriver() {
      this.$refs["selectLogisticDriverRef"].openDialog(this.waybillTaskData);
    },
    // 标记正常/异常
    onMarkLogistic(flag) {
      let url = "http://MID-OPERATE-LOGISTICS/messageService/carrierProxyService/updateProxyExceptionFlag";
      this.cfmInvoke(url, { dispatcherInfo: { dispatcherId: this.waybillTaskData.dispatcherId, exceptionFlag: flag } }, { msg: `确定标记为${flag ? "异常" : "正常"}吗？` }).then((res) => {
        this.$message.success("操作成功");
        this.$emit("onFinish");
        this.onFinish();
      });
    },
    // 更换司机
    onUpdateDriver(waybillId, dispatcherId, plateNo, vehicleTypeId, linkmanId, driverIdentityNo, driverMobile) {
      let param = {
        name: "",
        linkmanId: linkmanId,
        mobile: driverMobile,
        identityNo: driverIdentityNo,
        vehicleTypeId: vehicleTypeId,
        plateNo: plateNo
      };
      this.$refs["arrangeDriverVehicleRef"].openDialog(waybillId, dispatcherId, param);
    },
    // 取消司机安排
    onCancelDriver(logisticsSubTaskId) {
      let url = "http://MID-OPERATE-LOGISTICS/messageService/carrierProxyService/cancelDriverArrangement";
      this.cfmInvoke(url, { logisticsSubTaskId }, { msg: "确定取消司机安排？" }).then((rs) => {
        this.$message.success("操作成功");
        this.onFinish();
        this.$emit("onFinish");
      });
    },
    // 导出单个
    async onExportSingle(bizType, body, logisticTaskId, type = "") {
      let params = {
        body: { logisticSubTaskId: body.logisticSubTaskId }
      };
      if (bizType === "START_RENT") {
        params.exportId = "startRentDoc";
      } else if (bizType === "TERMINATE_RENT") {
        params.exportId = "terminateRentDoc";
        params.body.logisticTaskId = logisticTaskId;
      } else if (bizType === "SALE") {
        params.exportId = "tradeReceiveNote";
      } else if (bizType === "ADJUST" || this.waybillTaskData.goodsName) {
        params.exportId = "adjustDoc";
      } else if (type) {
        if (type === "装货单") {
          params.exportId = "terminateRentDoc";
          params.body.logisticTaskId = logisticTaskId;
        } else {
          params.exportId = "startRentDoc";
        }
      }
      let loadingInstance = Loading.service({ text: "签收单处理中..." });
      await this.download("/exportPDF", params);

      loadingInstance.close();
      return true;
    },
    // 判断是否有中化角色
    async getIsZhLeasee() {
      let url = "http://CORE-MEMBER/messageService/baseInfoService/queryIsZhMember";
      this.isZhLease = await this.invoke(url, { memberId: this.waybillTaskData.fromMemberId });
    },
    // 中化签收单
    async onZhExportSingle(row) {
      let loadingInstance = Loading.service({ text: "签收单处理中..." });
      let params = {
        exportId: "zhSignDoc",
        body: { logisticSubTaskId: row.logisticSubTaskId, logisticTaskId: this.waybillTaskData.logisticTaskId }
      };
      await this.download("/exportPDF", params);

      loadingInstance.close();
      return true;
    },
    // 添加备注
    onAddRemark() {
      this.$refs["addRemarkRef"].openDialog(this.waybillTaskData.dispatcherId, this.waybillTaskData.carrierRemark);
    },
    onFinishSeleDriver() {
      this.$emit("onFinish");
      this.getData(this.logisticsTaskId);
    },
    // 上传签收单
    onPushSignature(row) {
      this.$refs["pushSignatureRef"].openDialog({ ...row, ...this.waybillTaskData });
    },
    // 查看装卸货单
    openViewer(id) {
      this.$refs["elImageViewerRef"].openView(id, true);
    },

    // 导出png
    onExport(fileName, exportId, row, fileType, useFddSign = false) {
      this.$prompt("导出备注", `导出${fileName}`, { confirmButtonText: "导出", cancelButtonText: "取消" }).then(async ({ value }) => {
        await this.downloadFile(fileName, exportId, row, fileType, (useFddSign = false), value);
      });
    },

    async downloadFile(fileName, exportId, row, fileType, useFddSign = false, remark) {
      let params = {
        exportId: exportId,
        body: {
          logisticSubTaskId: row.logisticSubTaskId,
          logisticTaskId: row.logisticTaskId,
          useFddSign,
          remark
        }
      };

      if (fileType) {
        params.fileType = fileType;
      }

      let loadingInstance = Loading.service({ text: "加载中..." });
      await this.download("/exportPDF", params);
      loadingInstance.close();
    }
  }
};
</script>
<style lang='scss' scoped>
/deep/.el-button [class*="el-icon-"] + span {
  margin-left: 0;
}
/deep/.el-divider__text {
  font-weight: bold;
}
/deep/.el-card__body {
  padding: 20px !important;
}
/deep/.el-card__body,
.el-main {
  padding: 10px !important;
}

i {
  padding-right: 4px;
}

.task-order {
  display: flex;

  p {
    span {
      color: #606266;
    }
  }

  p:last-child {
    padding-left: 30px;
  }
}

.address {
  display: flex;
  align-items: center;

  .badge {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    margin-right: 6px;
    color: #fff;
    line-height: 22px;
    text-align: center;
  }

  .success {
    background: #67c23a;
  }

  .warning {
    background: #ff8800;
  }

  .region {
    width: calc(100% - 28px);
    span {
      font-size: 16px;
      color: #606266;
    }

    p {
      color: #909399;
    }
  }
}

.sub-task {
  display: flex;
  align-items: center;
  justify-content: center;

  .line {
    color: #909399;
    padding: 0 40px;
    text-align: center;
    white-space: nowrap;

    .long-line {
      display: block;
      color: #c0c2c5;
    }
  }

  li {
    flex: 1;

    .address {
      margin: 10px -8px;
    }

    & > p {
      padding: 4px 0;
      color: #606266;

      span {
        color: #909399;
        padding-left: 2px;
      }
    }

    .title-name {
      font-weight: bold;
      font-size: 16px;
    }

    .btns {
      height: 40px;
    }
  }
}

.plt-remark {
  color: #606266;

  span {
    color: #909399;
  }
}

.content {
  display: flex;
  justify-content: space-between;

  li {
    flex: 1;

    & > p {
      padding: 4px 0;
      color: #606266;

      span {
        color: #909399;
        padding-left: 2px;
      }
    }

    .remark {
      white-space: wrap;
    }
  }

  li:nth-child(3) {
    margin-left: 80px;
  }
}

section {
  .push-btn {
    text-align: right;
  }
}
</style>